import React, { useContext, useEffect } from "react";
import { useImmer } from "use-immer";
import { changePasswoCode, getProfiles, getTimeZone, update2FA } from "../..";
import { successMessage, errorMessage } from "../../../utils";
import { editProfile } from "../..";
import { changePassword } from "../..";
import { useNavigate, useLocation } from "react-router-dom";
import { AppContext } from "../../../store/AppScopeProvider";
import { useTabs } from "../../../shared";
import { AuthContext } from "../../../store";

export const useProfileSecurity = ({ profileData }) => {
  const { appState } = useContext(AppContext);
  const { setCurentTab } = useTabs();
  const { auth } = React.useContext(AuthContext);
  const { selectedStoreId, id, email } = auth.data;
  const location = useLocation();
  const navigate = useNavigate();

  const isStoreAdmin = location.pathname.includes("store-admin");
  const [state, setState] = useImmer({
    isOpen: false,
    isBusy: false,
    passCode: "",
    data: {
      two_factor_method: "email",
      is_two_factor_enabled: 1,
    },
    isSaveBtn: true,
  });

  useEffect(() => {

    if (profileData?.two_factor_method) {
      console.log(auth.data, profileData.two_factor_method);

      setState((draft) => {
        draft.data.two_factor_method = profileData.two_factor_method
        draft.data.is_two_factor_enabled = profileData.is_two_factor_enabled
      });
    }

  }, [profileData])

  const HandleChange = () => {
    navigate("/authentication/changePassword", {
      state: { from: isStoreAdmin ? "/store-admin/profile" : "/profile" },
    });
  };
  const resetPassCode = async () => {
    setState((draft) => {
      draft.isBusy = true;
    });
    try {
      const payload = {
        store_id: selectedStoreId,
      };
      const res = await changePasswoCode(payload, id);
      if (res.success) {
        setState((draft) => {
          draft.isBusy = false;
          draft.isOpen = true;
          draft.passCode = res.data.pass_code;
        });
      }
    } catch (err) {
      setState((draft) => {
        draft.isBusy = false;
      });
      errorMessage(err.response.data.message);
    }
  };
  const closeResetPassword = () => {
    setState((draft) => {
      draft.isOpen = false;
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target
    console.log(name, value, state);

    setState((draft) => {
      draft.data[name] = value
      draft.isSaveBtn = false
    });
  }

  const onSave2FA = async () => {
    try {
      setState((draft) => {
        draft.isSaveBtn = true;
      });
      const res = await update2FA(state.data);
      if (res.success) {
        successMessage(res.message)
      } else {
        setState((draft) => {
          draft.isSaveBtn = false;
        });
        errorMessage(res.message);
      }
    } catch (err) {
      setState((draft) => {
        draft.isSaveBtn = false;
      });
      errorMessage(err.response.data.message);
    }
  }

  return {
    state,
    email,
    isStoreAdmin,
    HandleChange,
    resetPassCode,
    closeResetPassword,
    handleInputChange,
    onSave2FA,
  };
};
